export const PAGE_SIZE_10 = 10;
export const CLEAN_AUTH = "CLEAN_AUTH";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const GET_PROFILE = "GET_PROFILE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const CLEAN_NAV = "CLEAN_NAV";
export const SET_DATA_LINE = "SET_DATA_LINE";
export const SET_FILTER_PART = "SET_FILTER_PART";
export const SET_FILTER_PART_DES = "SET_FILTER_PART_DES";
export const SET_FILTER_CODE = "SET_FILTER_CODE";
export const SET_FILTER_TASK = "SET_FILTER_TASK";
export const SET_FILTER_VIV = "SET_FILTER_VIV";
export const SET_FILTER_VARIETY = "SET_FILTER_VARIETY";
export const SET_FILTER_BATCH = "SET_FILTER_BATCH";
export const SET_FILTER_ARTICLE = "SET_FILTER_ARTICLE";
export const SET_FILTER_SECT = "SET_FILTER_SECT";
export const SET_FILTER_LOCATION = "SET_FILTER_LOCATION";
export const SET_FILTER_USER = "SET_FILTER_USER";





export const ROLE_TECHNICAL = "technical";
export const ROLE_SUPERVISOR = "supervisor";
export const ROLE_MANAGER = "manager";
export const ROLE_ADMIN = "admin";
export const ROLE_STAFF = "staff";

export const LANGUAGE_ES = {
  code: "es",
  label: "language.languages.es",
};
export const LANGUAGE_EN = {
  code: "en",
  label: "language.languages.en",
};
export const LANGUAGE_PT = {
  code: "pt",
  label: "language.languages.pt",
};

export const ROLES = [ROLE_TECHNICAL, ROLE_SUPERVISOR, ROLE_MANAGER];

export const LANGUAGES = [LANGUAGE_ES, LANGUAGE_PT, LANGUAGE_EN];

export const MONTHS = [
  {
    code: 1,
    label: "months.jan",
  },
  {
    code: 2,
    label: "months.feb",
  },
  {
    code: 3,
    label: "months.mar",
  },
  {
    code: 4,
    label: "months.apr",
  },
  {
    code: 5,
    label: "months.may",
  },
  {
    code: 6,
    label: "months.jun",
  },
  {
    code: 7,
    label: "months.jul",
  },
  {
    code: 8,
    label: "months.ago",
  },
  {
    code: 9,
    label: "months.sep",
  },
  {
    code: 10,
    label: "months.oct",
  },
  {
    code: 11,
    label: "months.nov",
  },
  {
    code: 12,
    label: "months.dec",
  },
];

export const STATUS_PART_PENDING = {
  code: "PENDING",
  label: "status.pending",
};
export const STATUS_PART_VALIDATED = {
  code: "VALIDATED",
  label: "status.validated",
};
export const STATUS_PART_CONFIRMED = {
  code: "CONFIRMED",
  label: "status.confirmed",
};

export const PART_STATUS = [
  STATUS_PART_PENDING,
  STATUS_PART_VALIDATED,
  STATUS_PART_CONFIRMED,
];

export const REPORT_TYPE_TASK_HOUR = {
  code: "TASK_HOUR",
  label: "forms.reports.type.taskHour",
};

export const REPORTS_TYPE = [REPORT_TYPE_TASK_HOUR];

export const CULTURE_OLIVO_LIMA = {
  code: "OLIVO_LIMA",
  label: "OLIVO_LIMA",
};
export const CULTURE_OLIVO_TURBA = {
  code: "OLIVO_TURBA",
  label: "OLIVO_TURBA",
};

export const CULTURE_OLIVO_GENERAL = {
  code: "OLIVO_GENERAL",
  label: "OLIVO_GENERAL",
};

export const CULTURE_GENERAL = {
  code: "GENERAL",
  label: "GENERAL",
};
export const CULTURE_ALMOND = {
  code: "ALMENDRO",
  label: "ALMENDRO",
};

export const CULTURES = [
  CULTURE_OLIVO_LIMA,
  CULTURE_OLIVO_TURBA,
  CULTURE_OLIVO_GENERAL,
  CULTURE_GENERAL,
  CULTURE_ALMOND,
];

export const ENABLE = {
  code: true,
  label: "yes",
};
export const DISABLE = {
  code: false,
  label: "no",
};

export const ACTIVE_STATUS = [ENABLE, DISABLE];

export const CODE_STATUS_ACTIVE = {
  code: "ACTIVE",
  label: "active",
};
export const CODE_STATUS_DISABLED = {
  code: "DISABLED",
  label: "disabled",
};

export const CODE_STATUS = [CODE_STATUS_ACTIVE, CODE_STATUS_DISABLED];

// INIT VIVERO CONSTANTS
export const CREATE_VIVERO = "CREATE_VIVERO";
export const GET_VIVERO = "GET_VIVERO";
export const UPDATE_VIVERO = "UPDATE_VIVERO";
export const DELETE_VIVERO = "DELETE_VIVERO";
export const FILTER_VIVERO = "const FILTER_VIVERO";
// END VIVERO CONSTANTS

// INIT VARIETY CONSTANTS
export const CREATE_VARIETY = "CREATE_VARIETY";
export const GET_VARIETY = "GET_VARIETY";
export const UPDATE_VARIETY = "UPDATE_VARIETY";
export const DELETE_VARIETY = "DELETE_VARIETY";
export const FILTER_VARIETY = "const FILTER_VARIETY";
// END VARIETY CONSTANTS

// INIT BATCH CONSTANTS
export const CREATE_BATCH = "CREATE_BATCH";
export const GET_BATCH = "GET_BATCH";
export const UPDATE_BATCH = "UPDATE_BATCH";
export const DELETE_BATCH = "DELETE_BATCH";
export const FILTER_BATCH = "const FILTER_BATCH";
// END BATCH CONSTANTS

// INIT TASK CONSTANTS
export const CREATE_TASK = "CREATE_TASK";
export const GET_TASK = "GET_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const FILTER_TASK = "const FILTER_TASK";
// END TASK CONSTANTS

// INIT ARTICLE CONSTANTS
export const CREATE_ARTICLE = "CREATE_ARTICLE";
export const GET_ARTICLE = "GET_ARTICLE";
export const UPDATE_ARTICLE = "UPDATE_ARTICLE";
export const DELETE_ARTICLE = "DELETE_ARTICLE";
export const FILTER_ARTICLE = "const FILTER_ARTICLE";
// END ARTICLE CONSTANTS

// INIT LOCATION CONSTANTS
export const CREATE_LOCATION = "CREATE_LOCATION";
export const GET_LOCATION = "GET_LOCATION";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const DELETE_LOCATION = "DELETE_LOCATION";
export const FILTER_LOCATION = "const FILTER_LOCATION";
// END LOCATION CONSTANTS

// INIT SECTOR CONSTANTS
export const CREATE_SECTOR = "CREATE_SECTOR";
export const GET_SECTOR = "GET_SECTOR";
export const UPDATE_SECTOR = "UPDATE_SECTOR";
export const DELETE_SECTOR = "DELETE_SECTOR";
export const FILTER_SECTOR = "const FILTER_SECTOR";
// END SECTOR CONSTANTS

// INIT CODE CONSTANTS
export const CREATE_CODE = "CREATE_CODE";
export const GET_CODE = "GET_CODE";
export const UPDATE_CODE = "UPDATE_CODE";
export const DELETE_CODE = "DELETE_CODE";
export const FILTER_CODE = "const FILTER_CODE";
// END CODE CONSTANTS

// INIT WORKING_PART CONSTANTS
export const CREATE_WORKING_PART = "CREATE_WORKING_PART";
export const GET_WORKING_PART = "GET_WORKING_PART";
export const UPDATE_WORKING_PART = "UPDATE_WORKING_PART";
export const UPDATE_PARTS_DATE = "UPDATE_PARTS_DATE";
export const DELETE_WORKING_PART = "DELETE_WORKING_PART";
export const FILTER_WORKING_PART = "const FILTER_WORKING_PART";
// END WORKING_PART CONSTANTS

/* GENERATOR_INJECT_CONSTANTS */
